import React from "react";

import './BannerCategory.css';

const BannerCategory = (props) => {
  return <div className="category__banner">{props.title}</div>;
};

export default BannerCategory;
